import portalProveedoresApi from '../api/portalProveedoresApi'
import authLogin from '../services/login-header'

const resetPasswordEmail = async (Hash, NewPassword) => {
  console.log(`portalResetPassword Email - Hash: ${Hash}`)
  try {
    // localStorage.setItem('hash', Hash)
    const { data } = await portalProveedoresApi.post('/ResetPassword', { Hash, Password: NewPassword }, { headers: authLogin() })
    console.log(data)
    return data
  } catch (error) {
    console.log('Error' + error)
    return null
  }
}

export default  resetPasswordEmail

